import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { USER } from 'src/app/core/user.service';
import { BaseHttpClient } from 'src/app/shared/flight-log-api/bases/base-client.service';
import { BaseEntity } from 'src/store/base/base.model';
import { filterNull } from 'src/util/rxjs/operators';
import { isNullOrEmpty } from 'src/util/string';
import { SelectItem, toSelectionList, toSelectItem } from 'src/util/ui/forms';
import { UserViewModel } from 'src/view-models/user-view-model';

@Component({
  selector: 'fl-base-autocomplete',
  templateUrl: './base-autocomplete.component.html',
  styleUrls: ['./base-autocomplete.component.scss'],
})
export class BaseAutocompleteComponent implements OnInit, OnDestroy {
  @Input()
  public baseId: UntypedFormControl;
  public initialSelectedItem$: Observable<SelectItem>;
  public options$: Observable<SelectItem[]>;
  public searches$ = new Subject<string>();
  public componentDestruction$ = new Subject<void>();

  constructor(@Inject(USER) private user: UserViewModel, private _bases: BaseHttpClient) {}

  public ngOnInit() {
    if (this.baseId.value !== null && !isNullOrEmpty(this.baseId.value)) {
      this.initialSelectedItem$ = this._bases
        .getById(this.baseId.value)
        .pipe(filterNull(), map(toSelectItem<BaseEntity>('name', 'id')));
    }

    this.options$ = this.searches$.pipe(
      switchMap((searchTerm) => {
        return this._bases
          .getAll({ companyId: this.user.companycode, searchTerm })
          .pipe(map(toSelectionList<BaseEntity>('name', 'id')));
      }),
    );
  }

  public ngOnDestroy() {
    this.componentDestruction$.next();
  }
  public onSearch(searchTerm: string) {
    return this.searches$.next(searchTerm);
  }
  public formatBaseNameLabel(item: SelectItem) {
    return `${item.label}`;
  }
}
